import React from "react";
import Layouts from "../layouts/Layouts";
import AppointmentForm from "../components/Appointment";
import { Card } from "reactstrap";
import { useRefContext } from "../components/ScrollToAppointment";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const formStyles = {
    section: {
      backgroundColor: "#ffffff",
      padding: "40px 0",
    },
    formWrapper: {
      backgroundColor: "#ffffff",
      borderRadius: "10px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    },
    formWrap: {
      padding: "30px",
    },
    input: {
      borderColor: "#ccc",
      borderRadius: "5px",
    },
    button: {
      borderColor: "#007bff",
    },
    image: {
      filter: "brightness(80%)",
    },
  };
  const { appointmentRef } = useRefContext();
  const { t } = useTranslation();

  return (
    <Layouts footer={2} noheader>
      {/*  <PageBanner
        title={t("pageBanner.contact")}
        pageName={t("pageBanner.contact")}
        pageNumber="4"
      />
     ====== Contact Info Section Start ======*/}

      <AppointmentForm
        ref={appointmentRef}
        side="right"
        imageNumber={2}
        styles={formStyles}
      />
      <section
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "40px",
          backgroundColor: "#f4f4f4",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
        className="bg-color-grey polygon-pattern-2"
      >
        <div
          style={{
            width: "100%",
            maxWidth: "800px",
            padding: "20px",
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              textAlign: "center",
              marginBottom: "30px",
            }}
          >
            <h2
              style={{
                fontSize: "2rem",
                fontWeight: "600",
                color: "#2c3e50",
              }}
            >
              {t("contactPage.info")}
            </h2>
            <span style={{ fontSize: "1rem", color: "#7f8c8d" }}>
              {t("contactPage.socials")}
            </span>
          </div>
          <Card
            style={{
              padding: "20px",
              backgroundColor: "#fff",
              border: "1px solid #ccc",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p
              style={{
                fontSize: "16px",
                color: "#7f8c8d",
                marginBottom: "10px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <strong>{t("contactPage.address")}:</strong>
              <span>{t("contactPage.addressValue")}</span>
            </p>

            <p
              style={{
                fontSize: "16px",
                color: "#7f8c8d",
                marginBottom: "10px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <strong>{t("contactPage.phone")}:</strong>
              <span>+918980863464</span>
            </p>

            <p
              style={{
                fontSize: "16px",
                color: "#7f8c8d",
                marginBottom: "10px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <strong>{t("contactPage.email")}:</strong>
              <span>imu52in@yahoo.com</span>
            </p>

            <p
              style={{
                fontSize: "16px",
                color: "#7f8c8d",
                marginBottom: "10px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <strong>{t("contactPage.socialMedia")}:</strong>
              <span></span>
            </p>

            <div>
              <p className="social-icon">
                <a
                  href="#"
                  style={{
                    color: "#213360",
                    fontSize: "1.5rem",
                    marginRight: "10px",
                  }}
                >
                  <i className="fab fa-facebook" />
                </a>
                <a
                  href="#"
                  style={{
                    color: "#213360",
                    fontSize: "1.5rem",
                    marginRight: "10px",
                  }}
                >
                  <i className="fab fa-twitter-square" />
                </a>
                <a
                  href="#"
                  style={{
                    color: "#213360",
                    fontSize: "1.5rem",
                    marginRight: "10px",
                  }}
                >
                  <i className="fab fa-linkedin" />
                </a>
                <a
                  href="#"
                  style={{
                    color: "#213360",
                    fontSize: "1.5rem",
                    marginRight: "10px",
                  }}
                >
                  <i className="fab fa-youtube-square" />
                </a>
              </p>
            </div>
          </Card>
        </div>
      </section>
      {/*====== Contact Info Section End ======*/}

      {/*====== Contact Form Start ======*/}

      <section
        style={{
          display: "flex",
          width: "100%",
          backgroundColor: "var(--color-fourth)",
          paddingTop: "40px",
          paddingBottom: "40px",
          position: "relative",
        }}
      >
        {/* Background Image (black icons collage with slight whitish filter) */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: "url('assets/img/section-bg/blue-section.png')",
            backgroundSize: "20%",
            backgroundRepeat: "repeat",
            backgroundPosition: "top left",
            filter: "brightness(0.7) contrast(1.2) saturate(0.5)",
            opacity: "0.2",
            zIndex: 1,
          }}
        />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            zIndex: 2,
          }}
        >
          {/* Section Heading */}
          <div style={{ textAlign: "center", marginBottom: "30px" }}>
            <h2
              style={{
                fontSize: "2.3rem",
                fontWeight: "700",
                color: "#fff",
                marginBottom: "10px",
              }}
            >
              {t("contactPage.scanQR")}
            </h2>
          </div>

          {/* Education & Experience Cards */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "30px",
              alignItems: "center",
              width: "80%",
            }}
          >
            <Card
              style={{
                padding: "20px",
                backgroundColor: "#fff",
                border: "1px solid #e2e2e2",
                borderRadius: "8px",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.05)",
                height: "320px",
                width: "320px",
                maxWidth: "600px",
                transition: "all 0.3s ease-in-out",
              }}
              className="card-glow"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                }}
              >
                {/* Role */}
                <img
                  src="assets/img/contact/map-qr.svg"
                  style={{}}
                  alt="map-QR"
                />
              </div>
            </Card>
          </div>
        </div>
      </section>
      {/*====== Contact Form End ======*/}

      <section
        className="contact-form-area"
        style={{ backgroundColor: "#f9f9f9", padding: "80px 0" }}
      >
        <div className="contact-map" style={{ marginBottom: "60px" }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.4436260038788!2d72.83433737602239!3d21.174528882754476!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04e63a5de0acb%3A0x9aefd33e3d6090c7!2sDr.%20Lakdawala%20Eye%20Hospital!5e0!3m2!1sen!2sin!4v1732273947267!5m2!1sen!2sin&maptype=satellite"
            width="100%"
            height="450"
            allowFullScreen=""
            title="Dr-Lakdawala-Eye-Hospital-Map-Location"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            style={{ border: "0" }}
          ></iframe>
        </div>
      </section>
    </Layouts>
  );
};

export default Contact;
